import Vue from 'vue'
import Vuex from 'vuex'
import loading from "./loading";
import reference from "./reference";
import http from "@/plugins/axios";
import TokenService from "@/utils/TokenService";
import {ROLES, TIME_OUT_REFRESH_TOKEN} from "@/utils/constants";
import Actions from './actions'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    me: null,
    mko: null,
    role: null,
    timeOutRefreshToken: 0,
    timeIntervalRefreshToken: null
  },
  getters: {
    mko: state => state.mko,
    me: state => state.me,
    role: state => state.role,
    isUserSuperAdmin: state => state.role === ROLES.superAdmin
  },
  mutations: {
    clearUser(state) {
      state.me = null
      state.mko = null
    },
  },
  actions: {
    clearTimeIntervalRefreshToken({state}) {
      clearInterval(state.timeIntervalRefreshToken)
      state.timeIntervalRefreshToken = null
      state.timeOutRefreshToken = 0
    },
    setTimeIntervalRefreshToken({state, dispatch}) {
      state.timeOutRefreshToken = TIME_OUT_REFRESH_TOKEN
      state.timeIntervalRefreshToken = setInterval(() => {
        state.timeOutRefreshToken--
        if (state.timeOutRefreshToken <= 0) {
          dispatch('clearTimeIntervalRefreshToken')
          dispatch('refreshToken')
        }
      }, 1000)
    },
    login({state, dispatch}, user) {
      return new Promise(async (resolve, reject) => {
        try {
          const {data: {access_token, expires_in, user_type}} = await http.post('auth/login', user)
          state.role = user_type
          TokenService.setToken(access_token, expires_in)
          resolve(true)
        } catch (e) {
          reject(e)
        }
      })
    },
    async getUser({state}) {
      try {
        const {data: {data}} = await http.post('auth/me')
        if (data) {
          state.me = data
          state.role = data.user_type
          const {mko_id} = data
          if (mko_id) {
            const {data: {data}} = await http.get(`admin/mko/${mko_id}`)
            state.mko = data.mko
          }
          return Promise.resolve()
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async refreshToken({dispatch, state}) {
      try {
        const {data: {access_token, user_type}} = await http.post('auth/refresh')
        TokenService.setToken(access_token)
        state.role = user_type
        dispatch('setTimeIntervalRefreshToken')
      } catch (e) {
        return Promise.reject(e)
      }
    }
  },
  modules: {
    loading,
    reference,
    Actions
  }
})
